import axios from 'axios';
import { PDFDocument } from 'pdf-lib';
import configs from '../constants/config';

const TEMPLATE_URL = `${configs.api_base_url}/onboarding-documents`;

export const downloadFilledTemplate = async ({ templateName, fileName, fill }) => {
  const template = await axios.get(`${TEMPLATE_URL}/${templateName}`, { responseType: 'arraybuffer' });
  const doc = await PDFDocument.load(template.data);
  const form = doc.getForm();

  fill({
    setText: (name, value) => {
      if (value) {
        form.getTextField(name).setText(String(value));
      }
    },
    uncheck: (names) => names.forEach((name) => form.getCheckBox(name).uncheck()),
  });

  const bytes = await doc.save();
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
